export const FIELD_TYPES = {
	DATE: "DATE",
	CATEGORY: "CATEGORY",
	USER: "KEYWORDS",
	TEXT: "TEXT",
	BOOLEAN: "BOOLEAN",
	DOCUMENT: "DOCUMENT",
};

export const CATEGORY_FILTER_LIST = ["frequency", "priority", "risk"];

export const BOOLEAN_FILTER_LIST = ["is_validated"];

export const DATE_FILTER_LIST = ["completion_deadline"];
